import AvatarUploadField from 'components/AvatarUploadField';
import React from 'react';
import { useSelector } from 'react-redux';
import { removeDraftUserAvatar, uploadDraftUserAvatar } from 'redux/modules/user.editor.actions';
import { getCanEditUserProfile, getDraft } from 'redux/selectors/user.editor';
import { useWithDispatch } from '~hooks/useWithDispatch';

const avatarActions = { uploadDraftUserAvatar, removeDraftUserAvatar };

/**
 * Lets an admin change the photo of the user open in the editor. Uploads and
 * removals save straight away (they don't wait for "Update person").
 */
const UserEditorAvatarField: React.FC = () => {
  const draft = useSelector(getDraft);
  const canEditProfile = useSelector(getCanEditUserProfile);
  const actions = useWithDispatch(avatarActions);

  if (!draft || !canEditProfile) {
    return null;
  }

  return (
    <AvatarUploadField
      layout="inline"
      size={64}
      avatarUrl={draft.avatar?.large_retina}
      name={draft.name}
      onUpload={actions.uploadDraftUserAvatar}
      onRemove={actions.removeDraftUserAvatar}
    />
  );
};

export default UserEditorAvatarField;
